module.exports = __webpack_public_path__ + "img/havefun_title_en.1b00751b.jpg";